module.exports = __webpack_public_path__ + "static/img/有好康300x300.395d93c4.png";